import script from "./course-layout-v5.vue?vue&type=script&setup=true&lang=js"
export * from "./course-layout-v5.vue?vue&type=script&setup=true&lang=js"

import "./course-layout-v5.vue?vue&type=style&index=0&id=1e9be532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9be532"]])

export default __exports__